import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { helper } from 'src/environments/helper';
import { CereriService } from '../cereri.service';
import { NotificationService } from 'src/app/services/notification.service';
import { UpdateMassPriorityPayload } from '../cereri.interface';

@Component({
    selector: 'app-cereri-prioritate',
    templateUrl: './cereri-prioritate.component.html',
    styleUrls: ['./cereri-prioritate.component.scss']
})
export class CereriPrioritateComponent {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    defaultParameter: { name: string; id: string } = {
        name: 'Toate',
        id: '-1',
    };

    requestPriorities: any[] = this.data.prioritateCerere;

    form: FormGroup = new FormGroup({
        id_cerere_priority: new FormControl('', [Validators.required]),
        message: new FormControl(''),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<CereriPrioritateComponent>,
        private cereriService: CereriService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;
        const ids_cerere = this.data.selectedRowIds;
        const currentPriorityValue = this.form.get('id_cerere_priority')?.value;
        const messageValue = this.form.get('message')?.value;

        const newPriority: UpdateMassPriorityPayload = {
            ids_cerere,
            id_cerere_priority: currentPriorityValue,
            message: messageValue,
        };

        this.cereriService
            .updateMassPriority(newPriority)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
